@import "node_modules/@se/web-ui/styles/_theme.scss";
//@import '../../../styles/global.scss';
//@import '../../../styles/variables.scss';
//@import '../../../styles/mixins/index.scss';

$tablet: map-get($breakpoints, tablet);
:host {
  display: block !important;
  outline: none !important; // Prevent wrong outline from se2-keyboard class on body added by another team!
}

.expanded {
  margin-left: -2.35rem;
  margin-right: -2.35rem;
}

.show-more {
  height: 20px;
}
